var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SmsContactSelectDialog',{ref:"contactSelectionForShareDialog",on:{"select-contact":_vm.openConversationOfSelectedContacts,"cancel-contact-selection":_vm.cancelContactSharing}})
}
var staticRenderFns = []

export { render, staticRenderFns }